<h1 mat-dialog-title>{{data?.title ?? 'Aktion bestätigen'}}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data?.text ?? 'Möchten Sie diese Aktion wirklich ausführen?'"></p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">Abbrechen</button>
  <button mat-flat-button [color]="data?.buttonColor ?? 'primary'" (click)="confirm()">Bestätigen</button>
</div>

